export const marketingPreviewBootStorageKey = (bootId) => `erp4c_marketing_boot_${bootId}`;

const MARKETING_PREVIEW_ACTIVE = 'erp4c_marketing_preview_active_tab';
const MARKETING_PREVIEW_ACCESS = 'erp4c_marketing_preview_access_token';
const MARKETING_PREVIEW_REFRESH = 'erp4c_marketing_preview_refresh_token';
const MARKETING_EMBED_MODE = 'erp4c_marketing_embed_mode';

export function isMarketingPreviewTab() {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem(MARKETING_PREVIEW_ACTIVE) === '1';
  } catch {
    return false;
  }
}

export function isMarketingEmbedMode() {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem(MARKETING_EMBED_MODE) === '1';
  } catch {
    return false;
  }
}

export function getMarketingAccessToken() {
  if (!isMarketingPreviewTab()) return null;
  try {
    return sessionStorage.getItem(MARKETING_PREVIEW_ACCESS);
  } catch {
    return null;
  }
}

export function getMarketingRefreshToken() {
  if (!isMarketingPreviewTab()) return null;
  try {
    return sessionStorage.getItem(MARKETING_PREVIEW_REFRESH);
  } catch {
    return null;
  }
}

export function activateMarketingPreviewTabSession(accessToken, refreshToken, { embed = true } = {}) {
  sessionStorage.setItem(MARKETING_PREVIEW_ACTIVE, '1');
  sessionStorage.setItem(MARKETING_PREVIEW_ACCESS, accessToken);
  sessionStorage.setItem(MARKETING_PREVIEW_REFRESH, refreshToken || '');
  if (embed) sessionStorage.setItem(MARKETING_EMBED_MODE, '1');
}

export function setMarketingPreviewTabTokens(accessToken, refreshToken) {
  if (!isMarketingPreviewTab()) return;
  sessionStorage.setItem(MARKETING_PREVIEW_ACCESS, accessToken);
  sessionStorage.setItem(MARKETING_PREVIEW_REFRESH, refreshToken || '');
}

export function clearMarketingPreviewTabSession() {
  sessionStorage.removeItem(MARKETING_PREVIEW_ACTIVE);
  sessionStorage.removeItem(MARKETING_PREVIEW_ACCESS);
  sessionStorage.removeItem(MARKETING_PREVIEW_REFRESH);
  sessionStorage.removeItem(MARKETING_EMBED_MODE);
}
